<p-toast position="top-right"></p-toast>

<div class="lock-List-Responsive p-g-12 p-dataView-tecfolk-fix ">
   <div class="p-g">
      <div class="p-g-12">
         <div class="card card-w-title">
            <h1>{{setLabel("lockedMembersLabel")}}</h1>
            <p-table #dt [value]="members" dataKey="id" styleClass=" p-table-customers req-management-table "
               [rowHover]="true" [rows]="100" [loading]="loading" [paginator]="true" [filterDelay]="0"
               [globalFilterFields]="['name','country.name','representative.name','status']" [first]="first"
               (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left;">

                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByMembeNameLabel")}}</span>
                           <input id="searchByName" #searchByName autocomplete="off" pinputtext=""
                              (keyup)="searchLocal(member.name, 'name')" [(ngModel)]="member.name"
                              [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByTagNumberLabel")}}</span>
                           <input id="searchByTagNumber" #searchByTagNumber autocomplete="off" pinputtext=""
                              (keyup)="searchLocal(member.tagNumber, 'tagNumber')" [(ngModel)]="member.tagNumber"
                              [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">

                           <span [pTooltip]='setLabel("clearTooltipLabel")' class="iconClear" [disabled]="loading" (click)="clear()"> <i
                                 class="pi pi-times"></i></span>
                        </div>
                     </div>
                     <div class="reportMainBtn">
                        <span [pTooltip]='setLabel("clearTooltipLabel")' class="iconClear hideOnLaptop" [disabled]="loading" (click)="clear()"> <i
                              class="pi pi-times"></i></span>
                        <!--
                        <button (click)="clear()"
                           class="clear-Button p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                              class="fa fa-eraser"></i>&nbsp;Clear
                           Search
                        </button> -->
                        <!-- <button style="background: #4CAF50; color: white;margin-top: 10px;"
                           class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                           <i class="fa fa-print" aria-hidden="true"></i> Print Products Stock Quantity
                        </button> -->
                     </div>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("tagNumberLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("profileLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("nameLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("mobile#Label")}}</th>
                     <th style="max-width: 130px;">{{setLabel("statusLabel")}}</th>
                     <!-- <th style="max-width: 130px;">Date</th> -->
                     <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr class="p-selectable-row">
                     <td>
                        <div class="mobile-Lable">{{setLabel("tagNumberLabel")}}</div>
                        {{rowData.tagNumber}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("profileLabel")}}</div>
                        <a (click)="openPhoto(rowData.profile, rowData.gender,$event)">
                           <img [alt]="" [src]=" rowData.profile
                           ? config.Server + config.memberImagePath + rowData.profile
                           : rowData.gender && rowData.gender == 'F'
                         ? 'assets/layout/images/avatarGirlImage.png'
                         : 'assets/layout/images/avatarBoyImage.png'"
                              onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="60"
                              style="vertical-align: middle; border-radius: 50%;" />
                        </a>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>{{rowData.name}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("mobile#Label")}}</div>{{rowData.contactDetail.contact}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("statusLabel")}}</div>
                        <div style="margin-right: 6px; padding-bottom: 10px;">
                           <p-inputSwitch name="Is_Delivery_Enabled" (onChange)="handleSwitchChange(rowData, $event)"
                              [(ngModel)]="rowData.isLocked">
                           </p-inputSwitch>
                        </div>

                        <div style="font-family: 'PrimeIcons';">
                           {{rowData.isLocked ? 'Locked' : 'Unlocked'}}
                        </div>
                     </td>
                     <!-- <td>{{rowData.createdOn | date: 'medium'}}</td> -->
                     <td style=" text-align: center !important;">
                        <div class="mobile-Lable">{{setLabel("actionLabel")}}</div>
                        <!-- <p-inputSwitch name="Is_Delivery_Enabled" (onChange)="handleSwitchChange($event)" [(ngModel)]="rowData.isLocked">
                        </p-inputSwitch> -->

                        <!-- <button pButton type="button" pTooltip="Unlock" style="margin-right: 5px;"
                                                      class="p-button-danger p-button" icon="fa fa-times">
                                                   </button> -->
                        <button pButton type="button" [pTooltip]='setLabel("viewDetailsTooltipLabel")' class="clear-btn" icon="fa fa-pencil-square-o"
                           (click)="viewMember(rowData)" style="margin-right: 5px;">
                        </button>
                     </td>
                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div>
   </div>
</div>

<div *ngIf="imgPreview" (click)="closePhotoPreview()"
   style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
   <svg (click)="closePhotoPreview()"
      style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;" aria-hidden="true"
      focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11" role="img"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
      <path fill="currentColor"
         d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
      </path>
   </svg>
   <img [src]="imgPreviewImg
   ? config.Server + config.memberImagePath +imgPreviewImg
   : 'assets/layout/images/avatarBoyImage.png'" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
      style="width: 25vw; height: auto;background: #fff;" />
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>